<template>
  <span>
    {{ getDescriptionText(value) }}
    <button
      v-if="value.length > lengthString"
      class="btn-link"
      @click="seeMore = !seeMore"
    >{{ !seeMore ? "Ver más" : "Ver menos" }}</button>
  </span>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      required: true,
      default: () => "",
    },
    lengthString: {
      type: Number,
      required: false,
      default: () => 40,
    },
  },
  data() {
    return {
      seeMore: false,
    };
  },
  methods: {
    getDescriptionText(text) {
      const { lengthString, seeMore } = this;
      if (text.length > +lengthString && !seeMore) {
        return text.substring(0, +lengthString) + "...";
      }
      return text;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Inputs/SeeMoreLess.vue